export default {
  customization: {}
}
